import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'

import image from '@loyal_images/products/placeholder.svg'

const MyOrdersPlaceholderItem = props => (
  props.page === 0 ? (
    <div className='col-12 px-1 order-item '>
      <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
        <div className='order-img col-3 txt-center pl-0 pr-2'>
          <div className='row align-items-center h-100'>
            <div className='col-12 txt-center'>
              <img src={image} alt='Ainda está carregando...' />
            </div>
          </div>
        </div>
        <div className='order-product-info col mr-auto'>
          <div className='order-product-info row'>
            <div className='product-infos col-12 mx-0'>
              <div className='row'>
                <div className='col-10 py-half bg-ui-4 radius mt-1' />
              </div>
              <div className='row mt-1'>
                <div className='col-5 py-half bg-ui-4 radius' />
              </div>
              <div className='row mt-1'>
                <div className='col-5 py-half bg-ui-4 radius' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : <Button loading text='Carregando' className='btn-flat' />

)

MyOrdersPlaceholderItem.propTypes = {
  page: PropTypes.any
}

export default MyOrdersPlaceholderItem



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/MyOrdersPlaceholderItem.js